// Hand-off from the marketing site. The register form on passcall.io creates the account
// through the registerFromSite Cloud Function and sends the browser here with either
//   https://my.passcall.io/#st=<custom token>   (sign in at once, no password retyped), or
//   https://my.passcall.io/?created=1&email=…   (the function could not mint a token:
//                                               show the sign-in form with the address filled in).
// Both are taken off the address as soon as they are read, so a reload or a bookmark
// never replays them. The custom token lives an hour and signs in one account.

/** The custom token from "#st=…", or null. Clears the fragment. */
export function handoffTokenFromUrl() {
  try {
    const hash = window.location.hash || "";
    if (!hash.startsWith("#")) return null;
    const params = new URLSearchParams(hash.slice(1));
    const token = params.get("st");
    if (!token) return null;
    params.delete("st");
    const rest = params.toString();
    window.history.replaceState(null, "", window.location.pathname + window.location.search + (rest ? "#" + rest : ""));
    return /^[A-Za-z0-9_.-]{20,4096}$/.test(token) ? token : null;
  } catch (e) {
    return null;
  }
}

/** { email } when the site sent someone here to sign in to a just-created account, else null. Clears the query. */
export function createdAccountFromUrl() {
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get("created") !== "1") return null;
    const email = (url.searchParams.get("email") || "").trim();
    url.searchParams.delete("created");
    url.searchParams.delete("email");
    window.history.replaceState(null, "", url.pathname + (url.search || "") + url.hash);
    return { email };
  } catch (e) {
    return null;
  }
}
